// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2dQfB","title":"styles_title__3N7E-","description":"styles_description__1UOQs","brand_v2":"styles_brand_v2__19Jcs","separator":"styles_separator__1e-sB"};